import { IGetObraAreaChecklistDropDownUseCase } from "../../../presentation/useCases/read/get_all_obra_area_checklist_drop_down_use_case";
import { ObraAreaChecklistDropDown } from "../../models/obra_area_checklist_dropdown";
import { IObrasRepository } from "../../repositories/obras_repository";

/**
 * GetObraAreaChecklistDropDownUseCase
 */

export class GetObraAreaChecklistDropDownUseCase implements IGetObraAreaChecklistDropDownUseCase {
  constructor(private readonly repository: IObrasRepository) { }

  async getObraAreaChecklistDropDown(
    idObra: number,
    obraChecklistServicosIds: number[] | undefined,
  ): Promise<ObraAreaChecklistDropDown[]> {
    const filteredObraChecklistServicosIds = obraChecklistServicosIds && obraChecklistServicosIds.length > 0
      ? obraChecklistServicosIds
      : null;

    return await this.repository.getObraAreaChecklistDropDown(
      idObra,
      filteredObraChecklistServicosIds,
    );
  }
}
